import { useLayoutEffect } from "react"
import { Link, Outlet } from "react-router"

import { useConfig } from "@/auth/mode"
import { Wordmark } from "@/brand/Wordmark"
import { removeBootScreen } from "@/lib/boot-screen"
import { AuthLanguageSwitch } from "./AuthLanguageSwitch"
import { AuthFooter } from "./SiteFooter"

/** The page behind the column. */
const PAGE_GROUND = "bg-surface-sunken"

/**
 * The content pages' frame (DV-158): the wordmark home, the language
 * switch, a reading column on a card, and the public footer. Open to
 * everyone, signed in or not. index.html's static first paint is the
 * sign-in screen, so it is removed at once.
 */
export function DocumentLayout() {
  const { data: config } = useConfig()
  useLayoutEffect(() => {
    removeBootScreen()
    document.body.classList.add(PAGE_GROUND)
    return () => {
      document.body.classList.remove(PAGE_GROUND)
    }
  }, [])
  return (
    <div className="flex min-h-dvh flex-col items-center px-4 pt-6 pb-10 sm:pt-10">
      <div className="flex w-full max-w-3xl items-center justify-between">
        <Link to="/" className="rounded-md focus-visible:outline-2 focus-visible:outline-ring">
          <Wordmark size="lg" className="text-lg font-semibold tracking-tight text-foreground" />
        </Link>
        <AuthLanguageSwitch />
      </div>
      <main className="mt-6 w-full max-w-3xl rounded-2xl border border-border bg-card px-5 py-8 shadow-sm sm:px-10 sm:py-10">
        <Outlet />
      </main>
      <AuthFooter supportEmail={config?.brand.supportEmail} mark="always" />
    </div>
  )
}
